import axios from 'axios'
import router from '../router'
import { useAuthStore } from '../stores/auth'

// Central Axios instance. All API calls go through here so the JWT and 401 handling
// are applied consistently. Base URL points at the .NET API's /api prefix.
const http = axios.create({
  baseURL: `${import.meta.env.VITE_API_BASE_URL}/api`,
})

// Attach the bearer token (read from the auth store, which hydrates from localStorage).
http.interceptors.request.use((config) => {
  const auth = useAuthStore()
  if (auth.token) {
    config.headers.Authorization = `Bearer ${auth.token}`
  }
  return config
})

// On 401, clear the session and bounce to login (unless already there).
http.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const auth = useAuthStore()
      auth.clear()
      if (router.currentRoute.value.name !== 'login') {
        router.push({ name: 'login' })
      }
    }
    return Promise.reject(error)
  },
)

export default http
